import { Divider, Text } from "theme-ui";
import { TabelHeadingTxt } from "../../Text/TabelCommonTxt";
import DataTable from "../../Tabels/Tabel";
import { useEffect, useMemo, useState } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getApiEndPoint } from "../../../utils/GenerateQueryString";

import moment from "moment";
import { getAllUserWithoutPagination } from "../../../store/actions/user.action";
import queryString from "query-string";
import { GetAllNeedInfo } from "../../../store/actions/project.action";

const NeedInfoView = () => {
    const { paginations } = useSelector((state: any) => state.pagination);
    const { needInfoView, loader } = useSelector((state: any) => state.project);
    const { dataForTable } = useSelector((state: any) => state.masterData);

    const userData = useSelector((state: any) => state?.user);
    const Users = userData?.userData?.data;
    const userOptions = Users?.map((user: any) => ({
        value: `${user?.FirstName} ${user?.LastName}`,
        label: `${user?.FirstName} ${user?.LastName}`,

    }));
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<boolean>(true);

    useEffect(() => {
        dispatch(getAllUserWithoutPagination())

    }, [dispatch])


    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            },
        },
        {
            accessorKey: "name",
            header: 'Name',
            cell: ({ row }) => (
                <Text>{row.original?.payload?.Description?.name || ''}</Text>
            ),
            enableColumnFilter: true,
            filterType: "textbox",
        },

        {
            header: 'Project Name',
            accessorKey: "projectId",
            cell: ({ row }) => (
                <Text>{row.original?.project?.name}</Text>
            ),
            filterType: 'dropdown',
            options: dataForTable?.data?.allProjects?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))
        },

        {
            header: 'Stage Name',
            accessorKey: "stageId",
            cell: ({ row }) => (
                <Text>{row.original?.stage?.temporaryName || row.original?.stage?.name || '-'}</Text>
            ),
            filterType: "dropdown",
            options: dataForTable?.data?.allStages?.map((val: { _id: string, name: string }) => ({ value: val._id, label: val.name }))
        },
        {
            header: 'Task Name',
            accessorKey: "taskId",
            cell: ({ row }) => (
                <Text>{row.original?.task?.name}</Text>
            ),
            filterType: 'textbox'
        },
        {
            header: 'Created By',
            accessorKey: "createdBy",
            cell: ({ row }) => (
                <Text>{row.original?.payload?.Description?.createdBy || ''}</Text>
            ),
            filterType: "dropdown",
            options: userOptions
        },
        {
            header: 'Created Date',
            accessorKey: "createdAt",
            cell: ({ row }) => {
                const createdDateValue = row.original?.payload?.Description?.createdAt;
                return (
                    <Text variant='Poppins14Normal24lh'>{createdDateValue ? moment(createdDateValue.split('T')[0]).format("MMM DD, YYYY") : ""}</Text>
                );
            },
            filterType: 'date',
        },

    ], [needInfoView?.data]);

    useEffect(() => {
        let apiEndPoint = getApiEndPoint({ limit, currentPage }, location.search, columns?.map((val: any) => ({ accessorKey: val.accessorKey, filterType: val.filterType })) || [])

        dispatch(GetAllNeedInfo(apiEndPoint))
        setRefresh(false);
    }, [refresh, location?.search, limit, currentPage])
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Need Info' Count={''} IsExportButtonShow={false} onClick={() => { }} sx={{ backgroundColor: '#7743DB', color: 'white' }} url={'/needinfo-view'} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={needInfoView?.data || []}
                TotalLength={needInfoView?.count || 15}
                perPageCount={limit || 15}
                currentPage={paginations.currentPage || 1}
                onPerPageChange={(itemsPerPage) => {
                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);
                        setSearchParams({
                            ...parsedQuery,
                            limit: itemsPerPage.toString(),
                        });
                    } else if (needInfoView?.data?.count < itemsPerPage) {
                        setSearchParams({
                            currentPage: '1',
                            limit: itemsPerPage.toString(),
                        });
                    }
                    else {
                        setSearchParams({
                            currentPage: currentPage.toString(),
                            limit: itemsPerPage.toString(),
                        });
                    }
                }}
                onPageChange={(value: string) => {

                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            currentPage: value.toString(),
                        });
                    } else {
                        setSearchParams({
                            currentPage: value.toString(),
                            limit: limit.toString(),
                        });
                    }

                }}

            />
        </div>
    )
}

export default NeedInfoView